import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OutOfSyncState } from '../../../../providers/nav-sidebar';
import { UserProvider } from '../../../../providers/user';
import { WhiteLabelProvider } from '../../../../providers/white-label';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'nav-sidebar-out-of-sync',
    templateUrl: 'nav-sidebar-out-of-sync.html'
})
export class NavSidebarOutOfSyncWarning {
    @Input() public currentState: OutOfSyncState;
    @Input() public enableStaticClassifier: boolean;
    @Input() public enableAnomalyHiFi: boolean;
    @Input() public isExpanded: boolean;

    /** Set to true to instead show a message that incremental training is needed */
    @Input() public showIncrementalTrainingWarning: boolean;

    @Output() onNavigate: EventEmitter<OutOfSyncState> = new EventEmitter();

    constructor(
        public whiteLabelProvider: WhiteLabelProvider,
        public userProvider: UserProvider,
        private translate: TranslateService
    ) {}

    public getOutOfSyncMessage(): string {
        if (this.currentState == OutOfSyncState.Detector) {
            return this.translate.instant('Brain out-of-sync');
        }

        if (this.currentState === OutOfSyncState.AnomalyRecognizer) {
            return 'Anomaly Recognizer';
        }

        if (this.currentState === OutOfSyncState.AnomalyHiFi) {
            return 'Anomaly Hi-Fi';
        }

        if (this.currentState === OutOfSyncState.LearningClassifier) {
            return 'Learning Classifier';
        }

        if (this.currentState === OutOfSyncState.StaticClassifier) {
            return 'Static Classifier';
        }

        if (this.currentState === OutOfSyncState.WhiteLabelLearningClassifier) {
            return this.translate.instant('Working Brain');
        }

        if (this.currentState === OutOfSyncState.WhiteLabelStaticClassifier) {
            const brainTranslated = this.translate.instant('Brain');
            return `${this.whiteLabelProvider.getBrainName()} ${brainTranslated}`;
        }

        return '';
    }

    public getTooltip(): string {
        if (this.showIncrementalTrainingWarning) {
            return this.getTooltipForIncrementalTraining();
        }

        return this.getTooltipForOutOfSync();
    }

    private getTooltipForIncrementalTraining() {
        const brainName = this.getBrainNameForTooltip();
        const outOfSyncMessage = this.translate.instant('[[brain]] needs training.', { brain: brainName });

        const tooltipSuffix = this.translate.instant('Click to train.');

        return `${outOfSyncMessage} ${tooltipSuffix}`;
    }

    private getTooltipForOutOfSync() {
        const brainName = this.getBrainNameForTooltip();

        const outOfSyncMessage = this.translate.instant('[[brain]] is out-of-sync.', { brain: brainName });

        let tooltipSuffix;

        if (
            this.currentState === OutOfSyncState.StaticClassifier ||
            this.currentState === OutOfSyncState.WhiteLabelStaticClassifier ||
            this.currentState === OutOfSyncState.AnomalyHiFi
        ) {
            tooltipSuffix = this.translate.instant('Click for rebuild options.');
        } else {
            tooltipSuffix = this.translate.instant('Click to retrain.');
        }

        return `${outOfSyncMessage} ${tooltipSuffix}`;
    }

    private getBrainNameForTooltip() {
        return this.currentState;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/nav-sidebar/out-of-sync-warning/nav-sidebar-out-of-sync.ts